import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change EXCEPT when only the language segment changes
// (i.e. the user switched language on the same page).
export default function useScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    const prev = prevPathRef.current;
    prevPathRef.current = pathname;

    // If there is a hash target, let the browser handle the anchor scroll.
    if (hash) return;

    const stripLang = (p) => {
      const parts = p.split("/").filter(Boolean);
      if (parts.length && (parts[0] === "ar" || parts[0] === "en")) {
        return "/" + parts.slice(1).join("/");
      }
      return p;
    };

    if (stripLang(prev) === stripLang(pathname)) {
      // Language-only change — do not scroll.
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return null;
}
